import { Compass, HeartHandshake, Scale, Sparkles } from 'lucide-react';

const qualities = [
  { icon: Compass, title: 'Discernment', text: 'Judging complexity beyond surface-level data.' },
  { icon: Sparkles, title: 'Intuition', text: 'Perceiving what cannot be reduced to explicit calculation.' },
  { icon: Scale, title: 'Conscience', text: 'Recognizing responsibility, restraint and the moral weight of choice.' },
  { icon: HeartHandshake, title: 'Relational meaning', text: 'Creating trust, belonging, empathy and shared purpose.' },
];

export default function NHISection() {
  return (
    <section className="intelligence-section intelligence-section--nhi section" id="nhi">
      <div className="container intelligence-grid intelligence-grid--reverse">
        <div className="intelligence-copy reveal">
          <span className="eyebrow"><i /> Natural Human Intelligence</span>
          <h2>The full spectrum of intelligence begins with the human.</h2>
          <p className="lead">
            NHI names the capacities machines can assist but cannot originate: perception, wisdom, conscience,
            empathy, restraint, beauty and meaning. The human remains the center of gravity and final decision-maker.
          </p>

          <div className="nhi-qualities">
            {qualities.map(({ icon: Icon, title, text }, index) => (
              <article key={title}>
                <span className="nhi-qualities__number">0{index + 1}</span>
                <Icon size={22} strokeWidth={1.55} />
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="intelligence-visual reveal reveal--delay">
          <div className="image-panel image-panel--nhi">
            <img src="/assets/nhi-architecture.webp" alt="Diagram explaining the semantic architecture of Natural Human Intelligence" />
          </div>
          <div className="human-center-card">
            <small>Center of gravity</small>
            <strong>The human</strong>
            <p>Origin · order · belonging</p>
          </div>
        </div>
      </div>
    </section>
  );
}
